import { render, staticRenderFns } from "./auditAuthOwnerList.vue?vue&type=template&id=e4b85d40&scoped=true"
import script from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
export * from "./auditAuthOwnerList.vue?vue&type=script&lang=js"
import style0 from "./auditAuthOwnerList.vue?vue&type=style&index=0&id=e4b85d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b85d40",
  null
  
)

export default component.exports